/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Link } from "react-router-dom";
import { qreq } from "../../../shared/qrequest";
import BaseCom from "../../BaseCom";
import Icon from "../../Icon";
import { SidebarGlobal } from "../../Sidebar";
import { withParamsAndNavigate } from "../../WithParamsAndNavigate";

class RuleManagerList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
    }

    async componentDidMount() {
        this.applyThemeColors();
        await this.getSettings();
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/rule/new')}><Icon icon="faPlus" /> <span className="d-none d-md-inline">New</span></button>
        </>);
        await this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/rule/list');
            if(j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }
        catch(e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>Rule Manager</h1>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th style={{ width: '25px' }}></th>
                            <th>Rule</th>
                            <th>Description</th>
                            <th>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list.map((item, idx) => {
                            return (
                                <tr key={idx}>
                                    <td><Link to={`/rule/${item.id}`}><Icon icon="faPencil" /></Link></td>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    <td>{item.priority}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withParamsAndNavigate(RuleManagerList);